import raw1 from "../assets/mark/1.svg?raw";
import raw2 from "../assets/mark/2.svg?raw";
import raw3 from "../assets/mark/3.svg?raw";
import rawCE from "../assets/mark/CE.svg?raw";
import rawEAC from "../assets/mark/EAC.svg?raw";

/** Keys match filenames in src/assets/mark/ */
export type MarkKey = "1" | "2" | "3" | "CE" | "EAC";

const RAW: Record<MarkKey, string> = {
  "1": raw1,
  "2": raw2,
  "3": raw3,
  CE: rawCE,
  EAC: rawEAC,
};

/** Native viewBox of each asset (for uniform fit inside 100×100 logical units). */
const INNER_VIEWBOX: Record<MarkKey, string> = {
  "1": "0 0 150 150",
  "2": "0 0 200 200",
  "3": "0 0 150 150",
  CE: "0 0 320 240",
  EAC: "0 0 141.73 141.73",
};

function stripSvgBoilerplate(raw: string): string {
  const txt = raw.replace(/<\?xml[^>]*\?>\s*/gi, "").trim();
  const doc = new DOMParser().parseFromString(txt, "image/svg+xml");
  const root = doc.documentElement;
  if (!root || root.localName.toLowerCase() !== "svg") return "";
  if (root.getElementsByTagName("parsererror").length) return "";

  const toRemove: Element[] = [];
  for (const el of root.querySelectorAll("*")) {
    const ln = el.localName.toLowerCase();
    if (ln === "metadata" || ln === "defs" || ln === "namedview") {
      toRemove.push(el);
    }
    if (ln === "g") {
      const st = el.getAttribute("style") ?? "";
      if (st.includes("display:none")) toRemove.push(el);
    }
  }
  for (const el of toRemove) el.remove();

  const sx = new XMLSerializer();
  return [...root.childNodes].map((n) => sx.serializeToString(n)).join("");
}

function applyMarkColor(svgInner: string, color: string): string {
  return svgInner
    .replace(/\.st0\s*\{[^}]*\}/gi, `.st0{fill:${color}}`)
    .replaceAll("#010101", color)
    .replaceAll("#000000", color)
    .replaceAll("#000", color);
}

/**
 * All marks share the same logical canvas 100×100 (square); inner asset scales with meet.
 * Display size is w×h px on the Konva stage (often 100×100).
 */
export function markIconSvg(mark: MarkKey, w: number, h: number, fill: string): string {
  let inner = stripSvgBoilerplate(RAW[mark]);
  inner = applyMarkColor(inner, fill);
  const vb = INNER_VIEWBOX[mark];
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet"><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="${vb}" preserveAspectRatio="xMidYMid meet">${inner}</svg></svg>`;
}
